import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux'; 
import store from './store'; 
import App from './App';
import { BrowserRouter as Router, useHistory } from "react-router-dom";
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import $ from 'jquery';
import 'bootstrap/dist/js/bootstrap.bundle';


window.store = store;

if (window.location.href.indexOf('QD3ccF085KKlHccDLNrm6xae3rCajW') > -1 ){
	window.location.href = 'https://www.shrevecu.org/connect/';
}


ReactDOM.render(
	<Router>
		<Provider store={store}>
			<App history={useHistory} />
		</Provider>
	</Router>,
	document.getElementById('root')
);


reportWebVitals();
